import React, { useEffect, Suspense } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { withErrorBoundary } from 'react-error-boundary';

import Router from 'Pages/router';
import ToastsWrapper from 'Components/Globals/ToastsWrapper';
import usePathname from 'Hooks/usePathname';
import { generalSelectors, generalActions, messageActions } from 'Ducks';
import PageLoading from 'Components/Globals/PageLoading/index';
import { ErrorPage } from 'Pages';
import ServicesProvider from '../ServicesProvider';

const PageProvider = (props) => {
	const { className, isInitializing, initializeApp, clearToasts } = props;

	const pathname = usePathname();
	const navigate = useNavigate();

	useEffect(() => {
		const initialize = async () => await initializeApp({ navigate, pathname });
		initialize();
	}, [initializeApp, navigate, pathname]);

	useEffect(() => {
		clearToasts();
	}, [pathname, clearToasts]);

	return (
		<div className={className}>
			{isInitializing ? (
				<p>app is starting...</p>
			) : (
				<Suspense fallback={<PageLoading />}>
					<ServicesProvider>
						<div>
							<Router />
							<ToastsWrapper />
						</div>
					</ServicesProvider>
				</Suspense>
			)}
		</div>
	);
};

PageProvider.defaultProps = {
	className: '',
};

PageProvider.propTypes = {
	isInitializing: PropTypes.bool,
	isSessionLoading: PropTypes.bool,
	initializeApp: PropTypes.func,
	clearToasts: PropTypes.func,
	className: PropTypes.string,
};

const mapStateToProps = (state) => {
	const sessionRequestType = 'userTypes.SESSION.REUQEST';
	return {
		isInitializing: generalSelectors.selectLoading(state),
		isSessionLoading: generalSelectors.selectApiLoadingStatus(
			state,
			sessionRequestType
		),
	};
};

const mapDispatchToProps = {
	initializeApp: generalActions.initializeStart,
	clearToasts: messageActions.clearNonPersistantToasts,
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(
	withErrorBoundary(PageProvider, {
		FallbackComponent: () => <ErrorPage />,
		onError: (error) => {
			console.error(error);
		},
	})
);
